import { render, staticRenderFns } from "./UrlAdder.vue?vue&type=template&id=7304966a&"
import script from "./UrlAdder.vue?vue&type=script&lang=js&"
export * from "./UrlAdder.vue?vue&type=script&lang=js&"
import style0 from "./UrlAdder.vue?vue&type=style&index=0&id=7304966a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports